import React from "react";

interface IPreviewHeaderProps {
  hideAddress?: boolean;
}
const PreviewHeader: React.FC<IPreviewHeaderProps> = ({
  hideAddress = false,
}) => {
  return (
    <table>
      <tbody>
        <tr>
          <td style={{ whiteSpace: "nowrap" }} colSpan={2}>
            <div className="main-title"> John Jacobson Limited</div>
            <div className="divider" />
          </td>
        </tr>
        <tr
          style={{
            display: hideAddress ? "none" : "table-row",
          }}
        >
          <td>
            <div>Phone (04) 569-5248</div>
            <div></div>
          </td>

          <td className="alignr">
            <div>107 Hutt Park Road</div>
            <div>Lower Hutt 5010</div>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default PreviewHeader;
